<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-app id="inspire">
      <v-layout
        wrap
        justify-center
        
        
      >
        <v-flex xs12 sm6 md6 lg4 px-2 align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs12 xl10>
              <v-snackbar
                v-model="showSnackBar"
                color="error"
                right
                :timeout="timeout"
              >
                <v-layout wrap justify-center>
                  <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
                  <v-flex text-right>
                    <v-btn
                      small
                      :ripple="false"
                      text
                      @click="showSnackBar = false"
                    >
                      <v-icon style="color: white">mdi-close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-snackbar>
              <v-card tile>
                <v-layout wrap justify-center>
                  <v-flex px-8 py-6>
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <span
                          style="
                            font-family: sofiaPro;
                            font-size: 18px;
                            color: black;
                          "
                          >Login
                        </span>
                      </v-flex>
                      <!-- <v-flex xs12  style="font-size:12px">
                     <span style="border-bottom: 1px soild red">   Enter your mobile number or Email  </span>
                      </v-flex> -->
                      <v-flex xs12>
                      
                        <v-layout wrap justify-center>
                          <v-flex
                            xs12
                            align-self-center
                            text-center
                            
                          >
                           <v-layout wrap>
                                  <v-flex pt-4 xs12 text-left>
                                    <v-layout wrap justify-center>
                                      <v-flex xs12 pb-2>
                                        <span
                                          style="
                                            font-family: sofialight ;
                                            font-size: 12px;
                                            color: black;
                                          "
                                        >
                                          Enter your Mobile Number 
                                        </span>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-form
                                          @submit.prevent="
                                            validateInput()
                                          "
                                        >
                                          <v-text-field
                                            ref="phone"
                                            color="#717171"
                                            placeholder="Mobile number"
                                            outlined
                                            dense
                                            type="number"
                                            v-model="phone"
                                            :rules="[rules.required, rules.min]"
                                          >
                                            <template v-slot:prepend-inner>
                                              <v-layout justify-center>
                                                <v-flex
                                                  pt-0
                                                  class="align-self-center"
                                                >
                                                  <span
                                                    style="
                                                      font-family: poppinsregular;
                                                      font-size: 15px;
                                                      color: #000;
                                                    "
                                                    >+91</span
                                                  >
                                                </v-flex>
                                                <v-flex pt-1 pl-2 xs1>
                                                  <v-divider
                                                    vertical
                                                  ></v-divider>
                                                </v-flex>
                                              </v-layout>
                                            </template>
                                          </v-text-field>
                                        </v-form>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 py-6>
                                    <v-btn
                                      block
                                     
                                      color="#E31E24"
                                      dark
                                      :ripple="false"
                                      depressed
                                      @click="validateInput()"
                                    >
                                      <span
                                        style="
                                          font-family: poppinssemibold;
                                          font-size: 12px;
                                          text-transform: none;
                                        "
                                        >Submit
                                      </span>
                                    </v-btn>
                                  </v-flex>
                                  <!-- <v-flex xs12 text-left>
                                    <v-icon color='#9D9D9D' small>mdi-home</v-icon><span style="font-size:12px;color:#9D9D9D;margin-left:8px">Back to home</span>
                                  </v-flex> -->
                                </v-layout>
                            <!-- <v-tabs v-model="tab">
                              <v-tab v-for="item in items" :key="item">
                                {{ item }}
                              </v-tab>
                              <v-tab-item>
                                <v-layout wrap>
                                  <v-flex pt-8 xs12 text-left>
                                    <v-layout wrap justify-center>
                                      <v-flex xs12 pb-2>
                                        <span
                                          style="
                                            font-family: ;
                                            font-size: 12px;
                                            color: #ababab;
                                          "
                                        >
                                          Mobile Number
                                        </span>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-form
                                          @submit.prevent="
                                            validateInput('signin')
                                          "
                                        >
                                          <v-text-field
                                            ref="phone"
                                            color="#717171"
                                            placeholder="Mobile number"
                                            outlined
                                            dense
                                            type="number"
                                            v-model="phone"
                                            :rules="[rules.required, rules.min]"
                                          >
                                            <template v-slot:prepend-inner>
                                              <v-layout justify-center>
                                                <v-flex
                                                  pt-0
                                                  class="align-self-center"
                                                >
                                                  <span
                                                    style="
                                                      font-family: poppinsregular;
                                                      font-size: 15px;
                                                      color: #000;
                                                    "
                                                    >+91</span
                                                  >
                                                </v-flex>
                                                <v-flex pt-1 pl-2 xs1>
                                                  <v-divider
                                                    vertical
                                                  ></v-divider>
                                                </v-flex>
                                              </v-layout>
                                            </template>
                                          </v-text-field>
                                        </v-form>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 py-6>
                                    <v-btn
                                      block
                                      tile
                                      color="#3EA56E"
                                      dark
                                      :ripple="false"
                                      depressed
                                      @click="validateInput('signin')"
                                    >
                                      <span
                                        style="
                                          font-family: poppinssemibold;
                                          font-size: 12px;
                                          text-transform: none;
                                        "
                                        >Continue
                                      </span>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-tab-item>
                              <v-tab-item>
                                <v-layout wrap>
                                  <v-flex pt-8 xs12 text-left>
                                    <v-layout wrap justify-center>
                                      <v-flex xs12 pb-2>
                                        <span
                                          style="
                                            font-family: ;
                                            font-size: 12px;
                                            color: #ababab;
                                          "
                                        >
                                          Mobile Number
                                        </span>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-form
                                          @submit.prevent="
                                            validateInput('signup')
                                          "
                                        >
                                          <v-text-field
                                            ref="phone"
                                            color="#717171"
                                            placeholder="Mobile number"
                                            outlined
                                            dense
                                            type="number"
                                            v-model="phone"
                                            :rules="[rules.required, rules.min]"
                                          >
                                            <template v-slot:prepend-inner>
                                              <v-layout justify-center>
                                                <v-flex
                                                  pt-0
                                                  class="align-self-center"
                                                >
                                                  <span
                                                    style="
                                                      font-family: poppinsregular;
                                                      font-size: 15px;
                                                      color: #000;
                                                    "
                                                    >+91</span
                                                  >
                                                </v-flex>
                                                <v-flex pt-1 pl-2 xs1>
                                                  <v-divider
                                                    vertical
                                                  ></v-divider>
                                                </v-flex>
                                              </v-layout>
                                            </template>
                                          </v-text-field>
                                        </v-form>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 py-6>
                                    <v-btn
                                      block
                                      tile
                                      color="#3EA56E"
                                      dark
                                      :ripple="false"
                                      depressed
                                      @click="validateInput('signup')"
                                    >
                                      <span
                                        style="
                                          font-family: poppinssemibold;
                                          font-size: 12px;
                                          text-transform: none;
                                        "
                                        >Continue
                                      </span>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-tab-item>
                            </v-tabs> -->
                          </v-flex>
                        </v-layout>
                        <!-- <v-layout wrap justify-center>
                          <v-flex xs5 lg6 xl2 px-2 pt-2>
                            <v-progress-linear
                              height="2"
                              value="100"
                              color="#EC2300"
                            ></v-progress-linear>
                          </v-flex>
                        </v-layout> -->
                      </v-flex>
                      <!-- <v-flex pt-8 xs12 text-left>
                        <v-layout wrap justify-center>
                          <v-flex xs12 pb-2>
                            <span
                              style="
                                font-family: ;
                                font-size: 12px;
                                color: #ababab;
                              "
                            >
                              Mobile Number
                            </span>
                          </v-flex>
                          <v-flex xs12>
                            <v-form @submit.prevent="validateInput">
                              <v-text-field
                                ref="phone"
                                color="#717171"
                                placeholder="Mobile number"
                                outlined
                                dense
                                type="number"
                                v-model="phone"
                                :rules="[rules.required, rules.min]"
                              >
                                <template v-slot:prepend-inner>
                                  <v-layout justify-center>
                                    <v-flex pt-0 class="align-self-center">
                                      <span
                                        style="
                                          font-family: poppinsregular;
                                          font-size: 15px;
                                          color: #000;
                                        "
                                        >+91</span
                                      >
                                    </v-flex>
                                    <v-flex pt-1 pl-2 xs1>
                                      <v-divider vertical></v-divider>
                                    </v-flex>
                                  </v-layout>
                                </template>
                              </v-text-field>
                            </v-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 py-6>
                        <v-btn
                          block
                          tile
                          color="#3EA56E"
                          dark
                          :ripple="false"
                          depressed
                          @click="validateInput"
                        >
                          <span
                            style="
                              font-family: poppinssemibold;
                              font-size: 12px;
                              text-transform: none;
                            "
                            >Continue
                          </span>
                        </v-btn>
                      </v-flex> -->
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["pageData", "backgroundImage",'type'],
  data() {
    return {
      userType: null,
      tab: null,
      items: ["Login", "Signup"],
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      formHasErrors: false,
      timeout: 5000,
      msg: null,
      phone: "",
      rules: {
        required: (value) => !!value || "Required",
        min: (value) => value.length == 10 || "Invalid Phone",
      },
    };
  },
  beforeMount() {
    if (this.pageData.phone) {
      this.phone = this.pageData.phone;
    }
  },
  computed: {
    form() {
      return {
        phone: this.phone,
      };
    },
  },
  methods: {
    validateInput() {
      this.userType = this.type;
      this.formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) {
          this.formHasErrors = true;
          this.msg = "Please Provide " + f;
          this.showSnackBar = true;
          return;
        }
        if (!this.$refs[f].validate(true)) {
          this.msg = "Please Provide Valid " + f;
          this.showSnackBar = true;
          this.formHasErrors = true;
          return;
        }
      });
      if (this.formHasErrors == false) this.login();
    },
    login() {
      var userData = {};
      userData["phone"] = this.phone;
      userData["accessType"] = "signup";
      this.appLoading = true;
      axios({
        method: "get",
        url: "user/signup/signin/send/otp",
        params: {
          phone: this.phone,
          accessType: this.userType,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (response.data.alreadyExists == false) {
              this.$emit("stepper", {
                phone: this.phone,
                winStep: 2,
              });
            }
            if (response.data.alreadyExists == true) {
              this.$emit("stepper", {
                phone: this.phone,
                winStep: 1,
              });
            }
          } else {

            // this.$emit("stepper", {
            //   phone: this.phone,
            //   winStep: 2,
            // });
             this.showSnackBar = true;
             this.msg = response.data.msg;
            
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>